module.exports = __webpack_public_path__ + "img/base_model1.7e482311.jpg";